var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"_flex":"~"}},_vm._l((_vm.data),function(item){return _c('tree-item',{key:item.id,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }